import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/app/admin/_common/ui/table";

export default function RoleListSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <Table
        containerClassName="min-h-0 flex-1 overflow-x-auto overflow-y-auto"
        className="min-w-[760px] table-fixed"
      >
        <TableHeader>
          <TableRow className="sticky top-0 z-10 hover:bg-muted [&>th]:bg-muted">
            <TableHead className="h-8 w-[28%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Role
            </TableHead>
            <TableHead className="h-8 w-[38%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Description
            </TableHead>
            <TableHead className="h-8 w-[16%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Permissions
            </TableHead>
            <TableHead className="h-8 w-[14%] text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              Users
            </TableHead>
            <TableHead className="h-8 w-12 pr-6 text-right" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: 4 }).map((_, index) => (
            <TableRow key={index} className="hover:bg-transparent">
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-32" />
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-56" />
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-8" />
              </TableCell>
              <TableCell className="py-1.5">
                <Skeleton className="h-4 w-8" />
              </TableCell>
              <TableCell className="w-12 py-1.5 pr-6 text-right">
                <Skeleton className="ml-auto size-6 rounded-md" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
